import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth as useOidcAuth } from "react-oidc-context";

import { UI_URL } from "shared/urls.constant";
import { useAuth } from "core/authentication/auth-context";
import FullPageSpinner from "components/FullPageSpinner";

function LoginRedirect() {
  const navigate = useNavigate();
  const auth = useOidcAuth();
  const { isAuthenticated } = useAuth();

  const tryAuthenticate = () => {
    if (isAuthenticated()) {
        navigate(UI_URL.HOME);
    } else {
        auth.signinRedirect();
    }
  };

  useEffect(() => {
    tryAuthenticate();
  }, []);

  return <FullPageSpinner message="Redirecting you to login page.." />;
}

export default LoginRedirect;
